export default __webpack_public_path__ + "static/media/B0001.a8d80b27.png";